var filter_FN = function(){
    filter = this;
    filter.init();
};
(function($){

    filter_FN.prototype = {

    	gadget : null,
        $footer: null,
		$form : null,
        $keyword : null,
        $editoria : null,
        $periodo : null,
        $data: null,
        $order : null,
        $submit : null,
        $clear : null,
        $toggle : null,
        $floater : null,
        initialValues : null,
        inSearchPage : false,

    	init : () => {

    		filter.gadget = Utils.getPageWidth() > 880 ? 'desktop' : 'mobile';
            filter.inSearchPage = document.querySelector( 'body' ).classList.contains( 'search' );
            filter.bindFilters();
            
        },

    	bindFilters : () => {

            filter.$footer = $( 'body > footer' )

			// Bind filters
            filter.$form = $( 'form.archive-filter' );
            filter.$keyword = $( 'input[data-key="keyword"]', filter.$form );
            filter.$submit = $( 'button[data-action="submit"]', filter.$form );
            filter.$clear = $( 'button[data-action="clear-keyword"]', filter.$form );
            filter.$floater = filter.$form.children( 'fieldset' ).first();
            filter.$open = $( 'button.toggle-filters', filter.$form );
            filter.$close = $( 'button[ data-action="close-floater"]', filter.$form );
	        filter.$editoriaHidden = $( '.mobile input[name="editoria"]', filter.$form );
            
            // Editoria e order
            if( filter.gadget === 'desktop' ){
            
                $( 'div.mobile', filter.$form ).remove();

	            filter.$editoria = $( '.desktop input[name="editoria"]', filter.$form );
                filter.$order = $( '.desktop input[name="ordenar-por"]', filter.$form );
                filter.$periodo = $( '.desktop input[name="periodo"]', filter.$form );
                filter.$data = $( '.desktop input[name="data"]', filter.$form );

            }
            else {

                $( 'div.desktop', filter.$form ).remove();
	        
                filter.$editoria = $( '.mobile input[data-machine-name="editoriamob"]', filter.$form );
                filter.$order = $( '.mobile input[data-machine-name="ordem"]', filter.$form );
                filter.$periodo = $( '.mobile input[data-machine-name="periodo"]', filter.$form );
                filter.$data = $( '.mobile input[data-machine-name="data"]', filter.$form );
               
            }

            // Initial values
			filter.initialValues = filter.extractFilters();

            // Form submit
            filter.$form.on( 'submit.Filter', function(e){
                var doSubmit = filter.$form.data( 'doSubmit' );
                if( doSubmit !== undefined && doSubmit === true ){
                    return true;
                }
                else {
                    e.preventDefault();
                    filter.validateFilters();
                }
            });

            // Submit
            filter.$submit.on( 'click', () => { filter.$form.submit() });

            // Check filters
            filter.$keyword.on('keyup', filter.checkFilters );
            filter.$editoria.on('change', filter.checkFilters );
            filter.$order.on('change', filter.checkFilters );
            if( filter.$periodo.length ){
                filter.$periodo.on('change', filter.checkFilters );
            }
            if( filter.$data.length ){
                filter.$data.on('change keyup', filter.checkFilters );
            }

            // Clear button
            filter.$clear.on( 'click', function(){
                filter.$keyword.val( '' );
                filter.$form.data( 'doSubmit', true );
                filter.$form.submit();
            });

            // Mobile
            filter.$open.on( 'click', event => {
            	event.preventDefault();
            	asn.lockScroll();
            	filter.$floater.addClass( 'opened' );
                filter.$footer.css( 'z-index', -1 )
            });
            filter.$close.on( 'click', event => {
            	event.preventDefault();
            	asn.unlockScroll();
            	filter.$floater.removeClass( 'opened' );
                setTimeout( () => {
                    filter.$footer.css( 'z-index', '' )    
                }, 500 )
                
            });
    	},

    	extractFilters : () => {

    		const 
    			$order = filter.$order.filter( ':checked' ),
    			$editoria = filter.$editoria.filter( ':checked' )
    		;

    		// Editorias
    		let editoria = '';
    		if( $editoria.length ){
    			if( $editoria.length > 1 ){
    				editoria = [];
    				$editoria.each(function(){
    					editoria.push( this.value );
    				});
    				editoria = editoria.join(',');
    			}
    			else {
    				editoria = $editoria.val();
    			}
    		}
    		
    		let values = {
    			keyword : filter.$keyword.val(),
    			editoria : editoria,
    			order : $order.length ? $order.val() : ''
    		};

            if( filter.$periodo.length ){
                const $periodo = filter.$periodo.filter( ':checked' );
                values.periodo = $periodo.length ? $periodo.val() : '';
            }

            if( filter.$data.length ){
                values.data = filter.$data.val();
            }

    		return values;
    	
    	},

    	checkFilters : () => {

    		const filters = filter.extractFilters();
            
    		let isInitial = true;
    		Object.keys( filters ).forEach( key => {
    			if( filters[ key ] !== filter.initialValues[ key ] ){
    				isInitial = false;
    			}
    		});

    		// Keyword value
    		const keyword = filter.$keyword.val();

    		// Submit button
    		if( isInitial || ( keyword !== '' && keyword.length < 3 ) ){
    			filter.$submit.prop( 'disabled', true );
    		}
    		else {
    			filter.$submit.prop( 'disabled', false );
    		}

    		// Clear button
    		if( keyword === '' ){
    			filter.$clear.fadeOut();
    		}
    		else {
				filter.$clear.fadeIn();
    		}

    	},

    	validateFilters : () => {

    		var keyword = filter.$keyword.val();
    		if( keyword === '' || keyword.length > 2 ){

    			// Remove empty fields
    			const values = filter.extractFilters();

    			// Keyword
    			if( !filter.inSearchPage && values.keyword === '' ){
    				filter.$keyword.removeAttr( 'name' );
    			}

    			// Order
    			if( values.order === '' || values.order === 'mais-recentes' ){
    				filter.$order.removeAttr( 'name' );
    			}

                // Periodo
                if( filter.$periodo.length && values.periodo === '' ){
                    filter.$periodo.removeAttr( 'name' );
                }

                // Data
                if( filter.$data.length && values.data === '' ){
                    filter.$data.removeAttr( 'name' );
                }

    			// Editorias
    			if( filter.gadget === 'mobile' ){
		        
		            if( values.editoria !== '' ){
		            	filter.$editoriaHidden.val( values.editoria );
		            }
		            else {
						filter.$editoriaHidden.removeAttr( 'name' );
		            }
		            filter.$editoria.removeAttr( 'name' );

	            }

    			// Do Submit
    			filter.$form.data( 'doSubmit', true );
                filter.$form.submit();
    		
    		}
    	
    	},

        isMobile : function(){
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        }

    };
	   
	window.addEventListener( 'load', function(){
        filter = new filter_FN();
    });

})(jQuery);